import EngineModule from '../../../EngineModule';
import * as STD     from '@emersya/mpa-std-lib';
import {
	NS as StandingPDFAccessoriesNS
}                   from '../../../components/customers/standing/StandingPDFAccessories/StandingPDFAccessories';

export default () => new EngineModule.LogicalEngineModule({
	type :             'logical',
	id :               'standing-pdfAccessories',
	dependencies :     [
		'oms-basket',
		'viewer-planner',
		'viewer-planner-layout-editor',
		'viewer-planner-dimensionsEditor'
	],
	allowedCustomers : [ /* Local MPA */'XUJG0A2TF5', /* Prod */'STAODAZNIS', 'sam1_12345' ],
	insertionPath :    'K.visualization.topRightMenu',
	generateComponentConfiguration() : StandingPDFAccessoriesNS.Configuration {
		const config = this.configuration;
		if (!this.translations.text) {
			throw STD.errors.user('Missing translations text for pdf Accessories');
		}
		const allLinkSource : any = {};
		for(const [key,value] of Object.entries(config)){
			if(key.startsWith('linkSource')){
				if(key === 'linkSource-en'){
					if(!allLinkSource['siae']){
						allLinkSource['siae'] = {
							'en' : value
						};
						allLinkSource['confort'] = {
							'en' : value
						};
						allLinkSource['prestige'] = {
							'en' : value
						};
						allLinkSource['business'] = {
							'en' : value
						};
					}else{
						allLinkSource['siae']['en'] = value;
						allLinkSource['confort']['en'] = value;
						allLinkSource['prestige']['en'] = value;
						allLinkSource['business']['en'] = value;
					}
				}else if(key === 'linkSource-fr'){
					if(!allLinkSource['siae']){
						allLinkSource['siae'] = {
							'fr' : value
						};
						allLinkSource['confort'] = {
							'fr' : value
						};
						allLinkSource['prestige'] = {
							'fr' : value
						};
						allLinkSource['business'] = {
							'fr' : value
						};
					}else{
						allLinkSource['siae']['fr'] = value;
						allLinkSource['confort']['fr'] = value;
						allLinkSource['prestige']['fr'] = value;
						allLinkSource['business']['fr'] = value;
					}
				}else{
					const product = key.split('-')[1];
					const language = key.split('-')[2];
					if(language && product){
						if(!allLinkSource[product]){
							allLinkSource[product] = {
							};
							allLinkSource[product][language] = value;
						}else{
							allLinkSource[product][language] = value;
						}
					}
				}
			}
		}
		return {
			imgSource :  config.imgSource,
			linkSource : allLinkSource,
			text :       this.translations.text
		};
	},
	async initialize() {
	}
});
